/**
 * タブ
 * @constructor
 */
class Tab {
  constructor() {

  }
  /**
   * タブ
   */
  init() {
    $('.js-tabBtn').on('click', eventObject => {
      $('.js-tabCont').removeClass("is-active");
      this.setName(eventObject.currentTarget);
      this.setTag();
      this.showContent();
    });
  }


   /**
   * data-tagの値を取得
   */
    setName(el) {
      const btn = $(el);
      const targetName = $(el).attr('data-tag');
      this.dataName = targetName;
      this.tagBtn = btn;
    }

    /**
     * data-tagの値を設定
     */
     setTag() {
      this.tag = $(`#${this.dataName}`);
    }

    /**
     * 商品詳細を表示
     */
     showContent() {
      this.tag.addClass("is-active");
    }
};

export default Tab;
